import store from '@/store/store';

export default {
    namespaced: true,
    state: {
      list: [],
      locationFavlist: [],
    },
    getters: {
        list: state => state.list,
        locationFavlist(state) {
        let selectedLocation = store.getters['location/selected'];
        if (_.isEmpty(selectedLocation)) {
          // if no location selected return all 
          return state.list;
        } else {
          // return only the fav product for the selected active location and product must not be discontinued
          return state.list.filter(item => {
            if(item.discontinued == false && item.location_id == selectedLocation.id) return item;
          })
        }
      },
    },
    mutations: {
        listMutate(state, data) {
            state.list = data;
        },
    },
    actions: {
        setList(context, data) {
          context.commit('listMutate', data);
        },
    },
};